// src/App.js - VERSÃO FINAL COMPLETA
import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoadingSpinner from './components/common/LoadingSpinner';

// Pages
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import Dashboard from './pages/dashboard/Dashboard';
import VocabularyPage from './pages/learning/VocabularyPage';
import ProfilePage from './pages/dashboard/ProfilePage';

// Main App Component (inside AuthProvider)
const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [currentPage, setCurrentPage] = useState('login');
  const [vocabularyCount, setVocabularyCount] = useState(0);

  // Navigation handler
  const handleNavigate = (page) => {
    setCurrentPage(page);
  };

  // Load vocabulary count for dashboard
  useEffect(() => {
    if (isAuthenticated) {
      // This could be moved to a context or service
      setVocabularyCount(22); // Placeholder - should come from API
    }
  }, [isAuthenticated]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return <LoadingSpinner message="Inicializando aplicação..." />;
  }

  // Authentication flow
  if (!isAuthenticated) {
    switch (currentPage) {
      case 'register':
        return (
          <RegisterPage 
            onSwitchToLogin={() => handleNavigate('login')} 
          />
        );
      default:
        return (
          <LoginPage 
            onSwitchToRegister={() => handleNavigate('register')} 
          />
        );
    }
  }

  // Authenticated app flow
  switch (currentPage) {
    case 'vocabulary':
      return <VocabularyPage onNavigate={handleNavigate} />;
    
    case 'characters':
      return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Caracteres</h2>
            <p className="text-gray-600 mb-4">Seção em desenvolvimento</p>
            <button
              onClick={() => handleNavigate('dashboard')}
              className="bg-green-500 text-white px-6 py-2 rounded-2xl hover:bg-green-600 transition-colors"
            >
              Voltar ao Dashboard
            </button>
          </div>
        </div>
      );
    
    case 'pronunciation':
      return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Pronúncia</h2>
            <p className="text-gray-600 mb-4">Seção em desenvolvimento</p>
            <button
              onClick={() => handleNavigate('dashboard')}
              className="bg-purple-500 text-white px-6 py-2 rounded-2xl hover:bg-purple-600 transition-colors"
            >
              Voltar ao Dashboard
            </button>
          </div>
        </div>
      );
    
    case 'conversation':
      return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Conversação</h2>
            <p className="text-gray-600 mb-4">Seção em desenvolvimento</p>
            <button
              onClick={() => handleNavigate('dashboard')}
              className="bg-orange-500 text-white px-6 py-2 rounded-2xl hover:bg-orange-600 transition-colors"
            >
              Voltar ao Dashboard
            </button>
          </div>
        </div>
      );
    
    case 'profile':
      return <ProfilePage onNavigate={handleNavigate} />;
    
    default:
      return (
        <Dashboard 
          onNavigate={handleNavigate}
          vocabularyCount={vocabularyCount}
        />
      );
  }
};

// Main App Component (with AuthProvider wrapper)
const App = () => {
  return (
    <AuthProvider>
      <div className="App">
        <AppContent />
      </div>
    </AuthProvider>
  );
};

export default App;